/**
 * Core: Tag handler
 * -----------------------------------------------------------------------------
 * <script> and <style> tags inside the Vue instance causes errors.
 * - Moves <script> and <style> tags outside of the Vue instance.
 * - Runs after app handler so app block tags are no longer in Vue instance when
 *   the tag handler runs.
 *
 */
import classes from '~/config/classes';

/**
 * DOM selectors.
 */
const selectors = {
  tags: '#vue-element script, #vue-element style',
};

/**
 * Create a new tag handler object.
 */
export default () => {
  /**
   * Initialise functionality.
   */
  function init() {
    return new Promise(async (resolve) => {
      const tags = [...document.querySelectorAll(selectors.tags)];

      /**
       * Move tags to the end of <body>.
       */
      const queue = tags.map((tag) => teleportContent(tag, document.body));

      await Promise.all(queue);
      resolve();
    });
  }

  /**
   * Teleport content to a different container.
   * @param {HTMLElement} element - Element to teleport.
   * @param {HTMLElement} destination - Element to teleport into.
   */
  function teleportContent(element, destination) {
    return new Promise((resolve) => {
      if (!element) {
        resolve();
        return;
      }

      element.classList.add(classes.moved);
      destination.appendChild(element);
      resolve();
    });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
